import React, { useState } from "react";
import { Button, Container } from "react-bootstrap";
import CreateTagModal from "@features/report/tag/components/CreateTagModal";
import { FiPlus } from "react-icons/fi";
import ReportTagTable from "../components/ReportTagTable";
import { useScopeId } from "@core/hooks/useRouteParamId";
import RequirePermission from '@core/components/RequirePermission';
import { ACTION_CODES } from '@features/entity/types/actionCodes';

const AdminTagsPage: React.FC = () => {
    const sid = useScopeId() ?? 0;
    const [showCreate, setShowCreate] = useState(false);
    const [refreshSignal, setRefreshSignal] = useState(0);


    return (<Container fluid className="py-4" data-testid="admin-tags-page-container">
        <div className="d-flex flex-column flex-md-row justify-content-md-between align-items-md-center gap-3 mb-4" data-testid="admin-tags-page-header-row">
            <div className="ntcog-page-title-block mb-0">
                <h1 className="ntcog-page-heading mb-1">Report Tags</h1>
                <p className="text-muted mb-0">Manage report tags</p>
            </div>
            {Number.isFinite(sid) && sid! > 0 && (
                <RequirePermission mode="section" action={ACTION_CODES.CREATE_REPORT_TAG} scopeType="NATION" scopeId={sid}>
                    <Button
                        variant="primary"
                        onClick={() => setShowCreate(true)}
                        aria-label="Create a new tag"
                        data-testid="new-tag-button"
                    >
                        <FiPlus className="me-2" />
                        New Tag
                    </Button>
                </RequirePermission>
            )}
        </div>

        <ReportTagTable
            nationId={sid}
            showPagination={true}
            refreshSignal={refreshSignal}
            data-testid="admin-report-tags-table"
        />

        <CreateTagModal
            show={showCreate}
            onHide={() => setShowCreate(false)}
            nationId={sid}
            onChanged={() => setRefreshSignal((s) => s + 1)}
        />
    </Container>
    );
};

export default AdminTagsPage;